import React from "react";
import PageHeadingSection from '../components/PageHeadingSection';
import CaseCard from '../components/cards/CaseCard';
import CreateCaseModal from '../components/CreateCaseModal';
import {useAuth} from '../util/auth';
import {fetchNewCasesPage} from '../util/pages';
import {useSelector} from 'react-redux';
import {makeGetCaseByStatus} from '../features/casesSlice';
import {CaseStatuses} from '../constants';
import SeoTags from '../components/SeoTags';
import {usePagination} from '../util/hooks/usePagination';
import {withUserGetServerSideProps} from '../util/util';
import {fetchCasesById, fetchCasesByStatus} from '../features/thunks';
import {wrapper} from '../store/store';
import {Button} from '../components/ui/button';
import {ImagePosition, ListCta} from '@/components/ListCta';

const newCasesSelector = makeGetCaseByStatus({
    selectedStatus: [CaseStatuses.SCHEDULED, CaseStatuses.NEW],
    sortKey: 'created',
    sortOrder: 'desc'
});

function NewCases(props) {
    const auth = useAuth();

    const {content = {}} = props;

    return <>
        <SeoTags config={content.seo} />
        <div className="container">
            <div className="mt-8 mb-16">
                <PageHeadingSection
                    backgroundImage={content.heading_background}
                    title={content.heading_title}
                    subtitle={content.heading_subtitle}
                >
                </PageHeadingSection>

                <div className="mt-4">
                    {auth.isAuthenticated ? (
                        <div className="flex items-center justify-end z-10">
                            <CreateCaseModal />
                        </div>
                    ) : null}
                    <div className="mt-6">
                        <CasesList statuses={[CaseStatuses.SCHEDULED, CaseStatuses.NEW]} orderBy="created" />
                    </div>
                </div>

                <div className="my-24">
                    <ListCta
                        className="bg-teal-400"
                        imgSrc={'/media/2023/man.svg'}
                        imgWidth={301}
                        imgHeight={288}
                        items={[
                            {
                                title: 'More to Explore',
                                text: '',
                                image: '',
                                list: [
                                    {text: 'Solving real-life challenges'},
                                    {text: 'Practicing leadership tools'},
                                    {text: 'Leaders from different cultures'},
                                    {text: '1,5-hour sessions'},
                                ]
                            },
                            {
                                title: 'More to Explore',
                                text: '',
                                image: '',
                                list: [
                                    {text: 'Professional executive coaches'},
                                    {text: 'Experienced mentors'},
                                    {text: 'Personal support and guidance'},
                                    {text: 'Preparing for promotion'},
                                ]
                            }
                        ]}
                        imagePosition={ImagePosition.Right}
                    />
                </div>
            </div>
        </div>
    </>;
}

const CasesList = ({statuses, orderBy}) => {

    const cases = useSelector(newCasesSelector);

    const {
        fetchNextPage,
        itemsLeft,
        hasNextPage
    } = usePagination({
        initialPageSize: 8,
        pageSize: 9,
        statuses,
        orderBy
    });

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {cases.map(({id}) => <CaseCard key={id} caseId={id} />)}
            </div>
            {hasNextPage ? (
                <div className="py-6 grid items-center">
                    <Button onClick={() => fetchNextPage()} variant="ghost">
                        Load more cases ({itemsLeft})
                    </Button>
                </div>
            ) : null}
        </>
    )
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
    const content = await fetchNewCasesPage();
    await ctx.store.dispatch(fetchCasesByStatus({
        limit: 8,
        offset: 0,
        orderBy: 'created',
        status: 'SCHEDULED,NEW',
        userId: ctx?.user?.id,
        ctx
    }));

    const caseId = ctx.query.caseId;

    if (caseId) {
        await ctx.store.dispatch(fetchCasesById({caseId, ctx}));
    }


    return { props: {content} }
}));

export default NewCases;
